import { SxStyleProp } from 'theme-ui';

const minHeightArray = ['revert', '650px', 'max(calc(100vh - 192px), 768px)'];

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    minHeight: minHeightArray,
    padding: ['20px 24px 0px', '0px'],
  },
  mainRowContainer: {
    paddingTop: ['0px', '108px'],
    minHeight: minHeightArray,
    flexWrap: ['wrap', 'no-wrap'],
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  mainRowContainerBoxLeft: {
    maxWidth: ['unset', '465px'],
    margin: ['auto', 'revert'],
  },
  mainRowContainerBoxRight: {
    alignSelf: 'flex-end',
    width: ['100%', '520px', '550px', '730px', '880px', '940px', '1100px'],
    paddingBottom: '15px',
  },
  title: {
    color: 'indigo.100',
    marginBottom: ['32px', '30px'],
    textAlign: ['center', 'left'],
  },
  intro: {
    marginBottom: '30px',
    textAlign: ['center', 'left'],
  },
  cta: {
    margin: ['0px auto 50px', '0px'],
  },
  backgroundImage: {
    backgroundSize: ['contain', 'cover !important'],
    backgroundPosition: ['center bottom', 'center'],
    minHeight: minHeightArray,
    ':before, :after': {
      backgroundSize: ['contain', 'cover !important'],
      backgroundPosition: ['center bottom', 'center'],
    },
  },
};
